import React from "react"
import Card from "@mui/material/Card"
import Grid from "@mui/material/Grid"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { Icon } from "@mui/material"

export interface FacilityInfoProps {
  facilityName: string
  facilityId: string
  phoneNumber: string
  address: string
  buildingType: number
  catvName: string
}

function FacilityInfo({
  facilityName,
  facilityId,
  phoneNumber,
  address,
  buildingType,
  catvName
}: FacilityInfoProps): React.ReactElement {
  return (
    <Card>
      <MDBox display="flex" alignItems="center" p={2} gap={2}>
        <Icon color="info" sx={{ fontSize: "60px !important" }}>
          {buildingType == 0 ? "domain" : "house"}
        </Icon>
        <MDTypography variant="h4" fontWeight="medium" textTransform="capitalize">
          {facilityName}
        </MDTypography>
      </MDBox>
      <MDBox p={3} pt={0}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <MDBox mb={2}>
              <MDTypography variant="button" color="text" fontWeight="medium">
                施設ID
              </MDTypography>
              <MDTypography variant="body2">{facilityId}</MDTypography>
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button" color="text" fontWeight="medium">
                電話番号
              </MDTypography>
              <MDTypography variant="body2">{phoneNumber}</MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6}>
            <MDBox mb={2}>
              <MDTypography variant="button" color="text" fontWeight="medium">
                住所
              </MDTypography>
              <MDTypography variant="body2">{address}</MDTypography>
            </MDBox>
            <MDBox mb={2}>
              {catvName != "" && (
                <>
                  <MDTypography variant="button" color="text" fontWeight="medium">
                    サービス提供元名
                  </MDTypography>
                  <MDTypography variant="body2">{catvName}</MDTypography>
                </>
              )}
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  )
}

export default FacilityInfo
